export enum UnqualifiedReason {
	NoQualification = 'NoQualification',
	Student = 'Student',
}
